// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useShellStore } from '../../stores/shellStore';
import { useAuth } from '../../hooks/useAuth';
import Button from './Button';
import './ProfileLoadWarning.css';

/**
 * Non-blocking warning shown when /api/v1/me returns 401 without a genuine
 * session expiry (e.g. the BFF couldn't resolve a profile from IAM). Unlike
 * SessionExpiredModal, this never forces logout — the user keeps working
 * and can retry the profile fetch or dismiss the warning.
 */
function ProfileLoadWarning() {
  const profileLoadError = useShellStore(s => s.profileLoadError);
  const setProfileLoadError = useShellStore(s => s.setProfileLoadError);
  const isAuthenticated = useIsAuthenticated();
  const { refetchMe } = useAuth();

  if (!profileLoadError || !isAuthenticated) return null;

  return (
    <div className="profile-load-warning" role="alert">
      <span className="profile-load-warning-text">
        We couldn&apos;t load your full profile. Some information may be missing or out of date.
      </span>
      <div className="profile-load-warning-actions">
        <Button variant="ghost" size="small" onClick={() => refetchMe()}>
          Retry
        </Button>
        <Button variant="ghost" size="small" onClick={() => setProfileLoadError(false)}>
          Dismiss
        </Button>
      </div>
    </div>
  );
}

export default ProfileLoadWarning;
